import React from "react";
import CourseLandingPage from "../components/CourseLandingPage";
import { COURSE_2 } from "../config/iGetToCourse";

/**
 * COURSE 2 LANDING — /i-get-to-deeper-return
 * "The Deeper Return — Keep Living I GET TO" ($8.88)
 */

const BRAND = { teal: "#068fa2", gold: "#d4af6a", mint: "#5EEAD4" };

export default function IGetToDeeperReturnPage() {
  return (
    <CourseLandingPage
      product={COURSE_2}
      showBundleCrossSell
      headline={
        <>
          The <span style={{ color: BRAND.mint, fontStyle: "italic" }}>Deeper</span>{" "}
          Return. <span style={{ color: BRAND.gold }}>For her.</span>
        </>
      }
      whoFor={{
        eyebrow: "Welcome back, Lovely",
        headlineNode: (
          <>
            You already did the brave thing.
            <br />
            <span className="italic" style={{ color: BRAND.teal }}>
              You learned the tools. Now we live them.
            </span>
          </>
        ),
        paragraphs: [
          "This is not Course 1, the sequel. This is the next turn of the spiral. The work that comes after the initial wake-up — the daily living of what you learned, in the body, in the relationships, in the long game.",
          "Course 2 is for the woman who's tasted the I GET TO shift and wants it to stay. Who's already started coming home to herself and is ready to sustain it, deepen it, embody it.",
          "Six movements. 18 pages. Yours forever for $8.88. Keep your Course 1 workbook beside you.",
        ],
      }}
      phasesTitle={
        <>
          Six movements.{" "}
          <span style={{ color: BRAND.mint, fontStyle: "italic" }}>
            Sustain it. Deepen it. Embody it.
          </span>
        </>
      }
      includes={[
        '"Remember this" recall in every lesson — anchoring what you already learned in Course 1.',
        '"Now go deeper" prompts — immediate, in-the-body practices that take the work past the surface.',
        '"Your turn — write it down to anchor it" journaling sections — the discipline that makes integration stick.',
        "Somatic literacy — how to read what your body's been trying to tell you all along.",
        "Discernment work — telling intuition from fear, your voice from your inheritance.",
        "Relapse-proofing — the early-warning signs of a spiral and how to come home faster.",
        "Legacy work — healing the line backward and forward through one woman's daily choices.",
        "The Long Game — becoming the elder you needed.",
      ]}
      honestNote={
        <>
          Honest note: this course assumes you've done Course 1 (or read the book). Each lesson
          starts with a "Remember this" — a one-line recall of a tool you've already learned —
          then takes you deeper. It's not new tools. It's the LIVING of the tools you already have.
          <br />
          <br />
          <span style={{ color: BRAND.teal, fontStyle: "normal", fontWeight: 500 }}>
            If Course 1 was the on-ramp, this is the highway. Welcome back.
          </span>
        </>
      }
      closer={{
        headlineNode: (
          <>
            The deeper work is the daily work.
            <br />
            <span style={{ color: BRAND.mint, fontStyle: "italic" }}>
              You're already in it.
            </span>
          </>
        ),
        paragraph:
          "Pick one Movement tonight. Read one lesson. Write one line. The spiral keeps turning. That's the practice.",
      }}
      metaDesc="The Deeper Return — Keep Living I GET TO. An 18-page integration intensive for women who've already done the brave thing in Course 1. Six Movements. Somatic literacy, discernment, legacy work, the Long Game. $8.88 by Temple Franklin."
      ldSku="MBSH-IGT-COURSE-2"
    />
  );
}
